import { CmdInterpreter } from 'BMapsCmds';
import { App } from 'BMapsSrc/BMapsApp';
import { EventBroker } from 'BMapsSrc/eventbroker';
import { wordsToCommands } from 'BMapsUtil/speech_utils';

/**
 * @description Takes a string input, converts it to commands using the commands API,
 * applies the resulting command representations, and publishes human friendly descriptions.
 * @param {string} input
 * @returns {Promise<void>}
 */
export async function applyWordsAsCommands(input) {
    if (!input || input.length === 0) {
        return;
    }

    const context = {
        focusCompound: App.Workspace.getActiveCompound()?.selectQuery,
    };
    const commandArr = await wordsToCommands(input, context);
    let interpretedCmds = [];
    EventBroker.publish('commandInput', { inputWords: input });
    if (Array.isArray(commandArr)) {
        await CmdInterpreter.interpretCommand(commandArr);
        interpretedCmds = commandArr.map(
            (cmd) => CmdInterpreter.printCommandInfo(cmd)
        );
    }
    EventBroker.publish('commandInput', { interpretedCmds });
}
